import { render, staticRenderFns } from "./marketing-campaign-details.vue?vue&type=template&id=13ea822a&"
import script from "./marketing-campaign-details.vue?vue&type=script&lang=ts&"
export * from "./marketing-campaign-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports